/**
 * Created by jayed.talukder on 9/16/2018.
 */
export class PaymentStream {

  public code: string;
  public title: string;
  public id: string;
  public threeLetterCode: string;
  public order: number;
  constructor (data?: any) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.code = '';
      this.title = '';
      this.id = '';
      this.threeLetterCode = '';
      this.order = 0;
    }
  }
}
